import { EventIds } from 'constants/index';
import { useCallback } from 'react';
import { useLazyQuery } from '@apollo/client';
import { PACK, PAGINATED_PACK_SAMPLES_QUERY } from 'apollo/pack/pack.gql';
import { Pack, RePack, Sample } from 'types';
import { log } from 'utils/log';

const usePackQuery = ({
    updatePreview,
    updateSamples,
}: {
    updatePreview: (entity: Pack | RePack) => void;
    updateSamples: ({
        items,
        total,
    }: {
        items: Sample[];
        total: number;
    }) => void;
}) => {
    const [getPack] = useLazyQuery(PACK, {
        onCompleted: (data) => {
            const pack = data?.pack;

            updatePreview(pack);
        },
        onError: (error) => {
            log.error(
                'Preview Pack failed',
                EventIds.FailedGetMerchZone,
                error,
            );
        },
    });

    const [getPackSamples] = useLazyQuery(PAGINATED_PACK_SAMPLES_QUERY, {
        onCompleted: (data) => {
            const paginatedPackSamples = data?.paginatedPackSamples;

            updateSamples({
                items: paginatedPackSamples?.data,
                total: paginatedPackSamples.meta?.totalSampleRecords,
            });
        },
        onError: (error) => {
            log.error(
                'Preview Paginated Pack samples failed',
                EventIds.FailedGetMerchZone,
                error,
            );
        },
    });

    const getPackPreview = useCallback(
        (guid: string) => {
            getPack({
                variables: { packSlugOrGuid: guid },
            });
            getPackSamples({
                variables: { packGuid: guid, take: 8 },
            });
        },
        [getPack, getPackSamples],
    );

    return getPackPreview;
};

export default usePackQuery;
